import {Donation} from '../shared/model/donation';
import {ControllerService} from '../shared/service/controller.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';
@Component({
  selector: 'app-step2-name',
  templateUrl: './step2-name.component.html',
  styleUrls: ['./step2-name.component.css']
})
export class Step2NameComponent implements OnInit {
  donationForm: NgForm;
  @ViewChild('donationForm')
  currentForm: NgForm;

  locale: string;
  controller: ControllerService;
  model: Donation;
  transFrequency: string;
  submitted = false;

  transParam: Object;
  translatedFrequency: string;
  step = 'step2';

  constructor(private router: Router, controller: ControllerService) {
    this.model = controller.getModel();
    this.controller = controller;
    this.locale = controller.locale;
    this.model.contact.locale = this.locale;

    const navigationStep = this.model.getIncompleteNavigationStep(0);
    console.log('Previous navigationSteps not complete navigating to: ' + navigationStep)
    if(navigationStep != null) {
      this.router.navigate([navigationStep]);
    }

  }

  ngOnInit() {
    this.controller.getTranslatedFrequency()
      .subscribe((trans) => {this.translatedFrequency = trans})
    this.transParam = {
      frequency: this.translatedFrequency,
      amount: this.controller.getCurSym() + this.model.payment.amount
    };
  }

  onSubmit() {
    this.submitted = true;
    console.log('submitted. Goto step 3');
    this.router.navigate(['/step3']);
    localStorage.setItem('name', this.model.contact.firstName);
  }

  localeSupportsPrefix(): boolean {
    return this.locale !== 'fr_fr' && this.locale !== 'tr_tr' && this.locale !== 'de_de';
  }
}
